<template>
	<a-modal :title="isUpdate ? '修改客服' : '新增客服'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="handleOk" @cancel="handleCancel">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:14}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>
				<a-form-model-item label="用户名" prop="username"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
					<a-input v-model="form.username" />
				</a-form-model-item>
				<a-form-model-item label="性别" prop="sex"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-select v-model="form.sex" style="width:100px" placeholder="请选择">
						<a-select-option value="MALE">男</a-select-option>
						<a-select-option value="FEMALE">女</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="登录名称" prop="loginName"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]">
					<a-input v-model="form.loginName" />
				</a-form-model-item>

				<a-form-model-item v-if="!isUpdate" label="登录密码" prop="loginPassword"
					:rules="loginPasswordRules">
					<a-input v-model="form.loginPassword" type="password" />
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';

	const fields = ['id', 'username', 'sex', 'loginName', 'loginPassword'];

	function emptyForm() {
		return {
			id: 0,
			username: '',
			sex: undefined,
			loginName: '',
			loginPassword: ''
		};
	}

	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				form: emptyForm(),
			}
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0 ? true : false;
			},
			loginPasswordRules() {
				if (this.isUpdate) {
					return [];
				}
				return [{ required: true, message: '必填，不能为空', trigger: 'blur' }];
			}
		},
		created() {
			this.$watch('model', (m) => {
				if (!m) {
					this.initForm();
					return;
				}
				this.$nextTick(() => {
					const base = pick(m, fields);
					this.form = { ...emptyForm(), ...base };
					if (this.isUpdate) {
						this.form.loginPassword = '';
					}
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			}, { immediate: true });
		},
		methods: {
			initForm() {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			handleOk() {
				this.$emit('ok');
			},
			handleCancel() {
				this.$emit('cancel');
				this.initForm();
			},
		}
	}
</script>

<style scoped>
	.ant-input-number-handler-wrap :deep(.ant-input-number-handler-wrap) {
		display: none;
	}
</style>
